const landing_page = {
  aboutUs: "Sobre nosotros", // translated
  topPackages: "Paquetes principales", // translated
  featuredHotels: "Hoteles destacados", // translated
  topTours: "Los mejores recorridos", // translated
  whatOurMembersSay: "Lo que dicen nuestros miembros...", // translated
  followUsOnInstagram: "Síguenos en Instagram", // translated
  pleaseWait: "Espere por favor...", // translated
  packages: "Paquetes", // translated
  trustedCarHirePartners: "Socios de alquiler de coches de confianza", // translated
  learnMore: "Aprende más", // translated
  ourPartners: "Nuestros compañeros", // translated
};

export default landing_page;
